import React, {useState} from "react";
import {DispatchOrder} from "../../types/DispatchOrder";
import {DispatchOrderStatusChange} from "../../types/DispatchOrderStatusChange";
import {DispatchOrderNotification} from "../../types/DispatchOrderNotification";
import {DateUtility} from "../common/DateUtility";

interface DispatchOrderStatusRecordsProps {
    dispatchOrder: DispatchOrder;
}

type StatusRecord = {
    id: string;
    created_at: string;
    pillLabel: string;
    detailText: string;
};

function formatTimestamp(dbDate: string): string {
    return DateUtility.dbDateToRequestedDisplayDate(dbDate).replace(' ', ', ');
}

function statusChangeToRecord(statusChange: DispatchOrderStatusChange): StatusRecord {
    return {
        id: `sc-${statusChange.id}`,
        created_at: statusChange.created_at,
        pillLabel: `Activity ${statusChange.dispatch_order_status.name}`,
        detailText: `Set at ${formatTimestamp(statusChange.created_at)} by ${statusChange.status_change_user.person.name}`,
    };
}

function notificationToRecord(notification: DispatchOrderNotification): StatusRecord {
    let pillLabel: string;
    if (notification.dispatch_order_status_change_id && notification.dispatch_order_status_change) {
        pillLabel = `${notification.dispatch_order_status_change.dispatch_order_status.name} Notification`;
    } else {
        pillLabel = "Notification";
    }
    let recipientNames = notification.dispatch_order_notification_recipients.map(
        recipient => recipient.recipient_user.person.name
    );
    return {
        id: `n-${notification.id}`,
        created_at: notification.created_at,
        pillLabel,
        detailText: `Sent at ${formatTimestamp(notification.created_at)} by ${notification.sender_user.person.name} to ${recipientNames.join(", ")}`,
    };
}

function buildStatusRecords(dispatchOrder: DispatchOrder): StatusRecord[] {
    let statusChangeRecords = dispatchOrder.dispatch_order_status_changes.map(statusChangeToRecord);
    let notificationRecords = dispatchOrder.dispatch_order_notifications.map(notificationToRecord);
    let allRecords = statusChangeRecords.concat(notificationRecords);
    allRecords.sort((a, b) => b.created_at.localeCompare(a.created_at));
    return allRecords;
}

export let DispatchOrderStatusRecords = function (props: DispatchOrderStatusRecordsProps) {
    let [expanded, setExpanded] = useState<boolean>(true);

    let statusRecords = buildStatusRecords(props.dispatchOrder);
    let newestRecord = statusRecords[0];

    return (
        <div className="dispatch-order-status-history-container">
            <div className="dispatch-order-status-history">
                <div className="status-history-header" onClick={() => setExpanded(!expanded)}>
                    <img
                        className="status-history-icon"
                        src="/static/images/status-records-icon.svg"
                    />
                    <div className="status-history-label">Status Records</div>
                    <div className="status-history-pill">{newestRecord ? newestRecord.pillLabel : ""}</div>
                    <div className="status-history-detail">{newestRecord ? newestRecord.detailText : ""}</div>
                    <img
                        className={`status-history-chevron${expanded ? " expanded" : ""}`}
                        src="/static/images/chevron-down-textcolor.svg"
                    />
                </div>
                {expanded && statusRecords.slice(1).map(record => (
                    <div className="status-history-row" key={record.id}>
                        <div className="status-history-pill">{record.pillLabel}</div>
                        <div className="status-history-detail">{record.detailText}</div>
                    </div>
                ))}
            </div>
        </div>
    );
};
